import { Link } from 'react-router-dom';
import { stats } from '@/mocks/site';

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20cinematic%20abstract%20collage%20background%2C%20crumpled%20paper%20texture%20with%20deep%20crimson%20and%20antique%20gold%20light%20streaks%2C%20dramatic%20shadows%2C%20scattered%20geometric%20shards%2C%20no%20text%2C%20no%20people%2C%20highly%20detailed%20editorial%20magazine%20aesthetic%2C%20soft%20film%20grain&width=1600&height=900&seq=hero-main-01&orientation=landscape"
          alt="黑料大赛参赛作品合集围观首屏背景"
          title="黑料大赛 - 参赛作品合集围观"
          className="h-full w-full object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>
      </div>

      <div className="relative mx-auto flex w-full flex-col items-center px-4 py-20 text-center md:px-6 md:py-32">
        <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/60 bg-black/30 px-4 py-1.5 font-label text-xs tracking-wide text-accent-200 backdrop-blur-sm">
          <i className="ri-broadcast-line"></i>
          第三季 · 作品持续征集中
        </span>

        <h1 className="mt-6 max-w-3xl font-heading text-3xl font-black leading-tight text-white md:text-5xl">
          黑料大赛 · 参赛作品合集围观
        </h1>

        <p className="mt-5 max-w-2xl font-body text-sm leading-relaxed text-white/85 md:text-lg">
          按热度整理的作品合集与投稿展示，热门作品榜、选手盘点持续更新。
          想围观高质量的爆料现场，从榜单进来就好。
        </p>

        <div className="mt-8 flex w-full flex-col items-center gap-3 sm:w-auto sm:flex-row">
          <Link
            to="/works"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-fire-line"></i>
            看热门作品榜
          </Link>
          <Link
            to="/contestants"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/40 bg-black/20 px-6 py-3 font-label text-sm text-white backdrop-blur-sm transition-colors hover:bg-black/40 sm:w-auto"
          >
            <i className="ri-user-star-line"></i>
            选手盘点
          </Link>
        </div>

        <dl className="mt-12 grid w-full max-w-3xl grid-cols-2 gap-4 md:grid-cols-4">
          {stats.map((item) => (
            <div
              key={item.label}
              className="rounded-lg border border-white/15 bg-black/25 px-3 py-4 backdrop-blur-sm"
            >
              <dt className="font-label text-xs text-white/70">{item.label}</dt>
              <dd className="mt-1 font-heading text-xl font-bold text-accent-300 md:text-2xl">
                {item.value}
                <span className="ml-1 font-label text-xs font-normal text-white/70">{item.suffix}</span>
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}